/**
 * Password validator for login pages
 */
import { zxcvbn } from './zxcvbn-setup';
import { NumbColorFunc, StringBoolFunc, StringNumFunc } from 'types/password';

const zxcvbnMinScore = 3;

// has number
const hasNumber: StringBoolFunc = (number) => new RegExp(/[0-9]/).test(number);

// has mix of small and capitals
const hasMixed: StringBoolFunc = (number) => new RegExp(/[a-z]/).test(number) && new RegExp(/[A-Z]/).test(number);

// has special chars
const hasSpecial: StringBoolFunc = (number) => new RegExp(/[!@#$$%^&*()]/).test(number);

export const strengthSteps = {
  poor: { id: 'poor', label: 'Poor', color: 'error', minScore: 3 },
  weak: { id: 'weak', label: 'Weak', color: 'warning', minScore: 4 },
  strong: { id: 'strong', label: 'Strong', color: 'success', minScore: 5 }
};

export const strengthColor: NumbColorFunc = (count, steps = strengthSteps) => {
  for (const step in steps) {
    if (count <= strengthSteps[step as keyof typeof strengthSteps].minScore) {
      return strengthSteps[step as keyof typeof strengthSteps];
    }
  }
};

// password strength indicator
export const strengthIndicator: StringNumFunc = (number) => {
  let strengths = 0;
  if (number.length > 7) strengths += 1;
  if (hasNumber(number)) strengths += 1;
  if (hasSpecial(number)) strengths += 1;
  if (hasMixed(number)) strengths += 1;

  const res = zxcvbn(number);
  if (res.score >= zxcvbnMinScore) strengths += 1;

  return strengths;
};
